import styled from "styled-components";
import { OptionIcon } from "@evergis/ui";

export const MenuWithOpacityContainer = styled.div`
  position: relative;
  width: 100%;
  max-height: 100vh;
  overflow: hidden;
`;

export const MenuScrollContainer = styled.div`
  width: 100%;
  max-height: calc(100vh - 18rem);
  overflow-y: auto;

  ${OptionIcon} {
    min-width: 1.125rem;
  }
`;

export const LayerOpacityContainer = styled.div`
  width: 100%;
  height: 2.5rem;
`;
